import Box from "@mui/material/Box";
import classNames from "classnames";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {SpaceBarOutlined} from "@mui/icons-material";
import React from "react";
import {useDispatch, useSelector, useStore} from "react-redux";
import {getActiveDrag, getMode} from "../../../state/ethereal/selectors";
import {handleJurorCardClick, updateJurorSeat} from "../../../state/asyncActions";
import {addSpacer} from "../../../db/actions";

import useStyles from "./JurorCard.styles";
import {ActionCreators} from "../../../state/ethereal/actions";
import {useViewBasedCardWidth} from "../../../util/hooks";
import SeatNumberEditor from "../SeatNumberEditor";

function EmptyJuryBoxSeat({caseId, seatNumber, spaceNumber, defaultSeatNumber, isCustomSeatNumber, isConflictSeatNumber}) {
    const classes = useStyles();
    const [showAdd, setShowAdd] = React.useState('hidden');
    const [showOutline, setShowOutline] = React.useState(false);
    const mode = useSelector(getMode);

    // The drag id is only needed at drop time; reading it from the store
    // there (instead of useSelector) avoids re-rendering every empty seat
    // when a drag starts or ends.
    const store = useStore();
    const minimumJurorCardWidth = useViewBasedCardWidth();
    const dispatch = useDispatch();

    function addSpacerRequested(e) {
        e.preventDefault();
        e.stopPropagation();
        addSpacer(caseId, spaceNumber);
    }

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();

        dispatch(handleJurorCardClick(caseId, null, seatNumber));
    }

    function handleMouseEnter(e) {
        setShowAdd('visible');
    }
    function handleMouseLeave(e) {
        setShowAdd('hidden');
    }

    function handleDragEnter(e) {
        e.preventDefault();
        setShowOutline(true);
    }

    function handleDragOver(e) {
        e.preventDefault();
        if (!showOutline) {
            setShowOutline(true);
        }
    }

    function handleDragLeave(e) {
        e.preventDefault();
        setShowOutline(false);
    }

    function handleDrop(e) {
        const activeDrag = getActiveDrag(store.getState());
        setShowOutline(false);
        if (activeDrag) {
            dispatch(updateJurorSeat(caseId, activeDrag, seatNumber));
        }
        dispatch(ActionCreators.setDrag(null));
    }

    let renderedClasses = classNames(classes.paper, classes.handle);
    if (showOutline) {
        renderedClasses = classNames(classes.paper, classes.handle, classes.outline);
    }

    return (
        <div style={{flex: 1, minWidth: minimumJurorCardWidth}}
             onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave}
             onDragEnter={handleDragEnter}
             onDragOver={handleDragOver}
             onDragLeave={handleDragLeave}
             onDrop={handleDrop}>
            <Box
                className={renderedClasses}
                onClick={handleClick}
                borderRadius="5px">
                <Box display="flex"
                     className={classes.header}>
                    <Box className={classNames(classes.autoMarginLeft, classes.header)}>
                        {seatNumber != null ? (
                            <SeatNumberEditor
                                caseId={caseId}
                                mode={mode}
                                spaceNumber={spaceNumber}
                                seatNumber={seatNumber}
                                defaultSeatNumber={defaultSeatNumber ?? seatNumber}
                                isCustom={!!isCustomSeatNumber}
                                isConflict={!!isConflictSeatNumber}
                            />
                        ) : ""}
                    </Box>
                </Box>
                <Box
                    display="flex"
                    flexGrow={1}
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                    style={{visibility: showAdd}}
                    p={2}
                >

                    <Tooltip title={"Add juror"}>
                        <IconButton color='primary' size='small'>
                            <AddCircleIcon style={{fontSize: 40}}/>
                        </IconButton>
                    </Tooltip>
                    <div style={{
                        position: 'absolute',
                        right: 10,
                        top: 0,
                        display: mode === "jury-box" ? "block" : "none"
                    }}>
                        <Tooltip title={"Add gap"}>
                            <IconButton size='small' onClick={addSpacerRequested}>
                                <SpaceBarOutlined/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </Box>
            </Box>
        </div>
    );
}

export default React.memo(EmptyJuryBoxSeat);